import emojis from '../assets/emojis';

export function emojiParser(shortcode: string): string {
  return emojis[shortcode];
}
